import { Button, Typography, Box } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

import MainLayout from '../../components/Layouts/MainLayout';

const Page404 = () => {
  const navigate = useNavigate();
  return (
    <MainLayout title="404">
      <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
        <Typography level="h3">Oops, we couldn&apos;t find this document.</Typography>
        <Typography level="h4"> Please try again later.</Typography>
        <Button onClick={() => navigate(-1)}>Go back</Button>
      </Box>
    </MainLayout>
  );
};

export default Page404;
